export enum openGoogleAiTypes {
    FETCH_OPENAI_HISTORY_REQUEST = 'OPENAI_HISTORY_REQUEST',
    FETCH_OPENAI_HISTORY_SUCCESS = 'OPENAI_HISTORY_SUCCESS',
    FETCH_OPENAI_HISTORY_FAILURE = 'OPENAI_HISTORY_FAILURE',
  }
